import { render, staticRenderFns } from "./ResponsiveUiList.vue?vue&type=template&id=db0a6460&scoped=true"
import script from "./ResponsiveUiList.vue?vue&type=script&lang=js"
export * from "./ResponsiveUiList.vue?vue&type=script&lang=js"
import style0 from "./ResponsiveUiList.vue?vue&type=style&index=0&id=db0a6460&prod&lang=scss"
import style1 from "./ResponsiveUiList.vue?vue&type=style&index=1&id=db0a6460&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db0a6460",
  null
  
)

export default component.exports